<template>
  <section class="content main-content-pass">
    <div class="card card-pass">
      <div class="card-body">
        <div class="title-container">
          <h4 style="text-align: left">Cambiar contraseña</h4>
          <hr />
        </div>
        <div>
          <div class="alert alert-danger" role="alert" v-if="errorMessage">
            {{ errorMessage }}
          </div>
          <form @submit.prevent="changePassword()">
            <div class="input-group mb-4">
              <input
                id="password"
                type="password"
                class="form-control"
                v-model="password"
                name="password"
                required
                autocomplete="new-password"
                autofocus
                placeholder="Contraseña nueva"
              />
              <div class="input-group-append">
                <div class="input-group-text">
                  <span class="fa fa-lock" style="font-size: 20px"></span>
                </div>
              </div>
            </div>
            <div class="input-group mb-4">
              <input
                id="confirmPassword"
                type="password"
                class="form-control"
                v-model="confirmPassword"
                name="password"
                required
                autocomplete="new-password"
                placeholder="Confirmar contraseña"
              />
              <div class="input-group-append">
                <div class="input-group-text">
                  <span class="fa fa-lock" style="font-size: 20px"></span>
                </div>
              </div>
            </div>
            <button type="submit" class="btn btn-secondary">Cambiar</button>
          </form>
        </div>

        <div
          class="modal fade"
          tabindex="-1"
          id="passwordModal"
          aria-hidden="true"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
        >
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Contraseña cambiada</h5>
              </div>
              <div class="modal-body">
                <p>Tu contraseña ha sido actualizada correctamente.</p>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="redirectHome"
                >
                  Volver al inicio
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axiosInstance from "../../services/axiosInstance";

import { Modal } from "bootstrap"; // Importar Bootstrap JS
export default {
  name: "CambiarPassword",
  data() {
    return {
      errorMessage: "",
      password: "",
      confirmPassword: "",
      modalInstance: null,
    };
  },
  methods: {
    async changePassword() {
      this.errorMessage = "";
      if (this.verifyPassword()) {
        try {
          await axiosInstance.post("/users/updatePassword", {
            password: this.password,
          });
          this.modalInstance.show();
        } catch (error) {
          this.errorMessage = "Ocurrio un error inesperado.";
        }
      }
    },

    verifyPassword() {
      if (this.password !== this.confirmPassword) {
        this.errorMessage = "Las contraseñas no coinciden.";
        return false;
      }
      return true;
    },

    redirectHome() {
      const cap = localStorage.getItem("role");
      if (cap == 1) {
        this.$router.push("/home");
      } else {
        this.$router.push("/home-cap");
      }
      this.modalInstance.hide();
    },
  },
  mounted() {
    this.modalInstance = new Modal(document.getElementById("passwordModal"), {
      backdrop: "static", // Evita que se cierre al hacer clic fuera
      keyboard: false, // Evita que se cierre con la tecla ESC
    });
  },
};
</script>

<style>
.main-content-pass {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  padding: 0 0.99rem;
}
.card-pass {
  width: 23rem;
}
</style>
